import PropTypes from 'prop-types';
import defaultBg from '../../../../images/slide-earth.png';

function PageHeader({ eyebrow, title, subtitle, bgImage = defaultBg }) {
  return (
    <header
      className="pt-80 px-40 pb-64 text-center max-sm:pt-64 max-sm:px-24 max-sm:pb-48 bg-no-repeat bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(15,23,42,0.88) 0%, rgba(30,58,138,0.85) 100%), url(${bgImage})`,
      }}
    >
      <p className="text-14 font-bold uppercase tracking-widest text-[#38BDF8] mb-16">
        {eyebrow}
      </p>
      <h1 className="text-48 font-extrabold text-white leading-[1.2] m-0 max-sm:text-36">
        {title}
      </h1>
      {subtitle && (
        <p className="text-20 text-white/80 max-w-640 mt-12 mx-auto leading-[1.75]">
          {subtitle}
        </p>
      )}
    </header>
  );
}

PageHeader.propTypes = {
	eyebrow: PropTypes.any,
	title: PropTypes.string,
	subtitle: PropTypes.any,
	bgImage: PropTypes.any
};

export default PageHeader;
